import { render, staticRenderFns } from "./CardWithImage.vue?vue&type=template&id=3deace06&scoped=true"
import script from "./CardWithImage.vue?vue&type=script&lang=js"
export * from "./CardWithImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3deace06",
  null
  
)

export default component.exports